export const formatDuration = (value = 0) =>
  value > 1 ? `${value} months` : `${value} month`;
